import { render, staticRenderFns } from "./TypeChecklistModelForm.vue?vue&type=template&id=181aec0a&"
import script from "./TypeChecklistModelForm.vue?vue&type=script&lang=js&"
export * from "./TypeChecklistModelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports